export default "__VITE_ASSET__C2ObUex4__"